import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿SAINT® usa anestesia?",
    answer:
      "No. SAINT® se administra con el paciente despierto, sin anestesia ni sedación. El paciente puede generalmente conducir al y desde la clínica cada día.",
  },
];

export const esDoesSaintRequireAnesthesia = makeEsArticle({
  slug: "does-saint-tms-require-anesthesia",
  title: "¿SAINT® requiere anestesia?",
  description:
    "No. SAINT® se administra con el paciente despierto, sin anestesia ni sedación, en un ambiente ambulatorio durante cinco días.",
  h1: "¿SAINT® requiere anestesia?",
  breadcrumbLabel: "¿SAINT® requiere anestesia?",
  shortAnswer:
    "No. SAINT® se administra con el paciente despierto, sin anestesia ni sedación. El tratamiento se realiza en un ambiente ambulatorio y el paciente puede generalmente conducir al y desde la clínica cada día. Esto la distingue del TEC (terapia electroconvulsiva), que suele requerir anestesia. SAINT® está autorizada por la FDA para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos.",
  keyTakeaways: [
    "SAINT® no usa anestesia ni sedación.",
    "El paciente permanece despierto.",
    "Se administra en un ambiente ambulatorio.",
    "El paciente puede generalmente conducir cada día.",
    "SAINT® está autorizada por la FDA para el trastorno depresivo mayor en adultos.",
  ],
  sections: [
    {
      heading: "Sin anestesia",
      paragraphs: [
        "SAINT® utiliza estimulación magnética transcraneal, no eléctrica. El paciente permanece despierto y alerta durante cada sesión. No se requiere anestesia, sedación ni una sala de recuperación.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
